/**
 * Converts merge field strings to markup to be deserialized.
 */
export const convertMergeFields = (string, mergeFields) => {
  let _string = string;

  const pattern = /{{([\w_]+?)}}/g;
  const matches = string.matchAll(pattern);
  const results = [...matches];

  if (results.length > 0) {
    results.forEach(result => {
      const [mergeField, name] = result;
      if (mergeFields[name]) {
        _string = _string.replace(mergeField, `<span merge-field="${mergeFields[name]}">${name}</span>`);
      } else {
        _string = _string.replace(mergeField, `<span merge-field="${name}" merge-field-error="true">${name}</span>`);
      }
    });
  }

  return _string;
};
